import {
  fetchWithStateBjorn,
  getFetchedJSON,
  fetchWithState,
  fetchWithStateBjornAndFile,
} from "~/misc/fetch";
import { getCode } from "~/misc/loadStatus";

export const getMyBookings = (getState) =>
  fetchWithStateBjorn(
    getState,
    {
      url: "/v2/bookings/list",
      method: "GET",
    },
    false
  )
    .then(getFetchedJSON)
    .then((res) => res.data || []);

export const creatBooking = (getState, postData) =>
  fetchWithStateBjorn(getState, {
    url: `/v2/bookings`,
    method: "POST",
    body: {
      shipment_id: postData.loadId,
      deadhead: postData.deadhead,
    },
  })
    .then(getFetchedJSON)
    .then((res) => {
      return {
        loadId: postData.loadId,
        bookingId: res.data,
        errors: res.api_errors,
      };
    });

export const cancelBooking = (getState, postData) =>
  fetchWithStateBjorn(
    getState,
    {
      url: `/v2/bookings/cancel/${postData.bookingId}`,
      method: "POST",
      body: {
        reject_reason: postData.rejectReason,
      },
    },
    false
  )
    .then(getFetchedJSON)
    .then((res) => {
      return {
        ...res,
        bookingId: postData.bookingId,
        loadId: postData.loadId,
      };
    });

export const deletBooking = (getState, delData) =>
  fetchWithStateBjorn(getState, {
    url: `/v2/bookings/${delData.bookingId}`,
    method: "DELETE",
  })
    .then(getFetchedJSON)
    .then((res) => {
      return { bookingId: delData.bookingId, loadId: delData.loadId };
    });

export const uploadFile = (getState, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return fetchWithStateBjornAndFile(getState, {
    url: `/files/upload`,
    method: "POST",
    body: formData,
  }).then(getFetchedJSON);
};

export const getNeedVerificationAPI = (getState, postData) =>
  fetchWithState(getState, {
    url: `/tl/booking/verification/check?brokerId=${postData.brokerId}&source=${postData.source}`,
    method: "POST",
  }).then(getFetchedJSON);

export const saveUploadFileAPI = (getState, postData) =>
  fetchWithStateBjorn(getState, {
    url: `POST /bjorn/v2/bookings/send_rc/${postData.loadId}`,
    method: "POST",
    body: {
      files: postData.files,
    },
  }).then(getFetchedJSON);

export const createBookDynamic = (getState, shipmentId,  nextNode, deadhead = 0) =>
fetchWithStateBjorn(getState, {
  url: `/v2/dynamic/book`,
  method: "POST",
  body: {
    shipment_id: shipmentId,
    next_node: nextNode,
    deadhead,
  },
}).then(getFetchedJSON).then(getCode)



// WEBPACK FOOTER //
// ./src/api/booking.js